import { JOBS_SITE_NAME } from '@hr-outsourcing/shared';
import { JOBS_SITE_URL, PEOPLY_PUBLIC_URL, PEOPLY_SITE_NAME } from '@/constants/jobsSite';

/** Whether the app runs on the listings' own domain, where its home is the listings page. */
export const isJobsSiteOrigin = (): boolean =>
  !!JOBS_SITE_URL && typeof window !== 'undefined' && window.location.origin === new URL(JOBS_SITE_URL).origin;

/**
 * Whether the candidate area (/careers) can be used here: on the listings' own domain when there is
 * one (on Peoply's site the server moves it there), anywhere otherwise.
 */
export const isCandidateAreaOrigin = (): boolean => !JOBS_SITE_URL || isJobsSiteOrigin();

/**
 * Whether the page is one of the candidate area or the public job pages, which keep their own
 * session guard: /careers, /jobs, or anything on the listings' own domain (its pages have no /jobs
 * prefix there).
 */
export const isCareersOrJobsPathname = (pathname: string): boolean =>
  isJobsSiteOrigin() || pathname.startsWith('/careers') || pathname.startsWith('/jobs');

/**
 * The site a public page's SEO tags (canonical, hreflang, Open Graph, JSON-LD) name: the listings'
 * own domain on it — nothing there points at peoply.ai — Peoply's public address elsewhere.
 */
export const publicSiteUrl = (): string => (isJobsSiteOrigin() ? JOBS_SITE_URL : PEOPLY_PUBLIC_URL);

/** The site's name in those tags and in page titles (the server's SITE_NAME on the listings' domain). */
export const publicSiteName = (): string => (isJobsSiteOrigin() ? JOBS_SITE_NAME : PEOPLY_SITE_NAME);
